export default {"src":"/_next/static/media/techcrunch.2a0f29f4.svg","height":17,"width":169};